import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import PATHCheckbox from "../ScreenComponents/PATHCheckbox.js";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { DialogContent, DialogTitle } from "@material-ui/core";
import { List, ListItem, ListItemText } from "@material-ui/core";
const useStyles = (theme) => ({
  headerClass: {
    color: "white",
    backgroundColor: theme.palette.primary.dark,
    padding: "15px",
    fontSize: "1em",
    textAlign: "center",
  },

  choiceClass: {
    color: "white",
    backgroundColor: theme.palette.primary.light,
  },
  dialog: {
    padding: theme.spacing(2),
    position: "absolute",
    top: theme.spacing(5),
  },
  formContainer: {
    position: "relative",
    height: "auto",
    padding: "2rem",
  },
  formControl: {
    margin: theme.spacing(0),
    minWidth: 150,
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogAction: {
    textAlign: "center",
  },
});

class EntryForm extends Component {
  state = {
    urgency: false,
    dbs: false,
    open: true,
  };

  continue = (e) => {
    e.preventDefault();
    this.props.currentContext.applyChoices();
    this.props.nextStep();
  };

  setUrgency = (val) => {
    //
    this.props.currentContext.setUrgency(val.target.checked);
    this.setState({ urgency: val.target.checked });
    //this.props.handleChange('urgency');
    //
  };

  setDBS = (val) => {
    //
    this.props.currentContext.setDBS(val.target.checked);
    this.setState({ dbs: val.target.checked });
    //this.props.handleChange('DBS');
    //
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
    this.props.currentContext.firstLoad = false;
  };

  render() {
    const { classes } = this.props;
    const { values, handleChange } = this.props;
    //const [show, setShow] = useState(true)

    return (
      <MuiThemeProvider>
        <Grid
          container
          spacing={2}
          direction="column"
          className={classes.formContainer}
        >
          {this.props.currentContext.firstLoad && (
            <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              maxWidth="md"
            >
              <DialogTitle
                style={{ backgroundColor: "#FAFAFA" }}
                className={classes.dialogTitle}
              >
                <Grid
                  container
                  item
                  xs={12}
                  spacing={1}
                  style={{ justifyContent: "center", alignItems: "center" }}
                >
                  <Grid item xs={12} style={{ marginBottom: 5 }}>
                    It remains critical for the Department to improve its
                    acquisition responsiveness as noted in the 2018 National
                    Defense Strategy.
                  </Grid>

                  <Grid item xs={6}>
                    {" "}
                    <ListItemText
                      secondary='"We face an ever more lethal and disruptive battlefield,
                      combined across domains, and conducted at increasing speed
                      and reach — from close combat, throughout overseas theaters,
                      and reaching to our homeland."'
                    />
                  </Grid>
                  <Grid item xs={6}>
                    {" "}
                    <ListItemText
                      secondary={
                        '"This increasingly complex security environment is defined by rapid technological change, challenges from adversaries in every operating domain, and the impact on current readiness from the longest continuous stretch of armed conflict in our Nation’s history."'
                      }
                    />
                  </Grid>
                </Grid>
              </DialogTitle>
              <DialogContent
                //className={classes.dialogContent}
                style={{ backgroundColor: "#FAFAFA" }}
              >
                <Grid container item xs={12} spacing={1}>
                  <Grid item xs={12}>
                    The need for a new acquisition effort may driven by some of
                    the following scenarios:
                  </Grid>
                  <Grid item xs={12}>
                    <List dense style={{ marginLeft: 20 }}>
                      <ListItem>
                        <ListItemText
                          primary="Joint Staff identifies a capability gap
                    that could be satisfied with multiple solutions. A
                    prototyping activity is required to help identify which is
                    the best candidate to develop and scale into production."
                        ></ListItemText>
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary=" A program manager receives a new threat brief and realizes
                    that the effort underway (maybe in EMD phase) is not going
                    to be adequate to the new threat environment and needs to
                    identify available innovations that can ensure the relavence
                    of the system when delivered."
                        ></ListItemText>
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary="A lab or commercial
                    provider responds to a technology open call with a novel
                    solution that government experts quickly realize could be a
                    force multiplier. A prototype is established to prove it out
                    operationally and if successful leave a residual capability
                    in the hands of the warfighter."
                        ></ListItemText>
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary="A COCOM recognizes that
                    they are lacking the material capabilities to satisfy a
                    mission set and need an interim solution until a longer-term
                    fix can be planned. "
                        ></ListItemText>
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary=" A COCOM is utilizing an operational
                    prototype as a stop-gap measure but realizes that the
                    prototype has a high-level of effectiveness and would like
                    to scale it across the force."
                        ></ListItemText>
                      </ListItem>
                    </List>
                  </Grid>
                </Grid>
              </DialogContent>
            </Dialog>
          )}
          {/*FORM OPTIONS<Grid item container direction="column" spacing ={2}>*/}
          <Grid item xs={6}>
            {/*Project Name*/}
            <TextField
              placeholder="Enter Your Project Name"
              label="Project Name"
              onChange={handleChange("projectName")}
              defaultValue={values.projectName}
              variant="outlined"
              style={{ width: "100%", margin: "1rem 0" }}
            />
          </Grid>

          {/*Project Nature*/}
          <Grid item xs={6}>
            <FormControl className={classes.formControl}>
              <InputLabel
                style={{
                  width: "100%",
                  margin: "0 1rem",
                }}
                id="demo-controlled-open-select-label"
              >
                Project Nature
              </InputLabel>
              <Select
                variant="outlined"
                style={{ width: "100%" }}
                labelId="demo-controlled-open-select-label"
                id="demo-controlled-open-select"
                defaultValue={values.projectNature}
                onChange={handleChange("projectNature")}
                value={values.projectNature}
              >
                <MenuItem value={"NAT1"}>
                  Prototyping a promising technology for integration into a
                  program of record
                </MenuItem>
                <MenuItem value={"NAT2"}>
                  Prototyping a promising technology to deploy a minimum
                  operational capability
                </MenuItem>
                <MenuItem value={"NAT3"}>
                  Fielding a commercial or mature technology to meet a specific
                  operational need
                </MenuItem>
                <MenuItem value={"NAT4"}>
                  Development of or upgrade to a hardware platform or sensor
                </MenuItem>
                <MenuItem value={"NAT5"}>
                  Development of software upgrades for an existing weapons
                  platform
                </MenuItem>
                <MenuItem value={"NAT6"}>
                  Development of software to be fielded or upgraded using
                  commercial hardware
                </MenuItem>
              </Select>
              <FormHelperText>Describe the Nature of the Effort</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item container direction="row">
            {/*Urgency*/}
            <Grid item xs={6}>
              <PATHCheckbox
                currentContext={this.props.currentContext}
                nameVal="Urgent"
                stateID="urgency"
                checkedVal={this.props.currentContext.urgency}
                description="Is the project based on an approved Urgent Operational Need?"
                handler={this.setUrgency}
                disabled={this.props.currentContext.checkUrgencyDisabled()}
              />
            </Grid>

            {/*DBS*/}
            <Grid item xs={6}>
              <PATHCheckbox
                currentContext={this.props.currentContext}
                nameVal="Defense Business System"
                stateID="DBS"
                checkedVal={this.props.currentContext.DBS}
                description="Does the project meet the definition of a defense business system as defined by 10 USC 2222?"
                handler={this.setDBS}
                disabled={this.props.currentContext.checkDBSDisabled()}
              />
            </Grid>
          </Grid>

          {/*Project Costs*/}
          <Grid item xs={6}>
            <FormControl className={classes.formControl}>
              <InputLabel id="costs-select-label">Expected Costs</InputLabel>
              <Select
                labelId="costs-select-label"
                id="costs-open-select"
                value={values.EstCosts}
                onChange={handleChange("EstCosts")}
              >
                <MenuItem value={"ACAT I"}>
                  RDT&E greater than $525 million or procurement greater than
                  $3.065 billion
                </MenuItem>
                <MenuItem value={"ACAT II"}>
                  RDT&E greater than $200 million or procurement greater than
                  920 million
                </MenuItem>
                <MenuItem value={"ACAT III"}>
                  RDT&E less than $200 million or procurement less than $920
                  million
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={1} />

          {/*Continue Button*/}
          <Grid item container direction="row" spacing={1}>
            <Grid item xs={12}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={this.continue}
              >
                Continue
              </Button>
            </Grid>
          </Grid>

          {/*End Options Grid*/}
          {/*</Grid>*/}

          {/*End dialog Grid*/}
        </Grid>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(EntryForm);
